<template>
  <div class="row ">
    <div class="col-md-4">
      <book-section
        :publishing="publishing"
        :is-management-mode="isManagementMode"
        @img-cover-uploaded="handleImgCoverUploaded"
      />
    </div>
    <div class="col-md-8 col-12">
      <div class="container">
        <p v-if="languages.length > 1">
          <b-link
            @click="handleGoToCornerForLanguage(language)"
            class="fw-bold"
          >
            {{ language }}
          </b-link>
        </p>
        <h1 class="fw-bolder font-48">
          {{ title }}
          <span class="ico ico-share">
            <svg
              @click="openShare"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9997 1.99996C11.2633 1.99996 10.6663 2.59691 10.6663 3.33329C10.6663 4.06967 11.2633 4.66663 11.9997 4.66663C12.7361 4.66663 13.333 4.06967 13.333 3.33329C13.333 2.59691 12.7361 1.99996 11.9997 1.99996ZM9.33301 3.33329C9.33301 1.86053 10.5269 0.666626 11.9997 0.666626C13.4724 0.666626 14.6663 1.86053 14.6663 3.33329C14.6663 4.80605 13.4724 5.99996 11.9997 5.99996C10.5269 5.99996 9.33301 4.80605 9.33301 3.33329Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.99967 6.66663C3.26329 6.66663 2.66634 7.26358 2.66634 7.99996C2.66634 8.73634 3.26329 9.33329 3.99967 9.33329C4.73605 9.33329 5.33301 8.73634 5.33301 7.99996C5.33301 7.26358 4.73605 6.66663 3.99967 6.66663ZM1.33301 7.99996C1.33301 6.5272 2.52692 5.33329 3.99967 5.33329C5.47243 5.33329 6.66634 6.5272 6.66634 7.99996C6.66634 9.47272 5.47243 10.6666 3.99967 10.6666C2.52692 10.6666 1.33301 9.47272 1.33301 7.99996Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9997 11.3333C11.2633 11.3333 10.6663 11.9302 10.6663 12.6666C10.6663 13.403 11.2633 14 11.9997 14C12.7361 14 13.333 13.403 13.333 12.6666C13.333 11.9302 12.7361 11.3333 11.9997 11.3333ZM9.33301 12.6666C9.33301 11.1939 10.5269 9.99996 11.9997 9.99996C13.4724 9.99996 14.6663 11.1939 14.6663 12.6666C14.6663 14.1394 13.4724 15.3333 11.9997 15.3333C10.5269 15.3333 9.33301 14.1394 9.33301 12.6666Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.42135 8.90698C5.60673 8.58886 6.01489 8.48125 6.33301 8.66663L10.333 11C10.6511 11.1853 10.7587 11.5935 10.5734 11.9116C10.388 12.2297 9.97982 12.3373 9.66171 12.152L5.6617 9.81864C5.34359 9.63326 5.23598 9.2251 5.42135 8.90698Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5728 4.08815C10.7584 4.40615 10.651 4.81438 10.333 4.99996L6.33838 7.48488C6.02038 7.67045 5.61215 7.5631 5.42657 7.2451C5.24099 6.9271 5.34834 6.51887 5.66634 6.33329L9.66097 3.84838C9.97897 3.6628 10.3872 3.77015 10.5728 4.08815Z"
                fill="#A1B1BA"
              />
            </svg>
            <div class="share-popup" v-if="showSearch">
              <span @click="shareToFacebook(slug)" class="ico ico-fb">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.1173 0H0.882667C0.395333 0 0 0.395333 0 0.882667V15.1173C0 15.6053 0.395333 16 0.882667 16H8.54533V9.804H6.45933V7.39H8.54533V5.60667C8.54533 3.54067 9.808 2.41667 11.6513 2.41667C12.5347 2.41667 13.294 2.48133 13.5153 2.51067V4.67067H12.2347C11.2347 4.67067 11.04 5.15133 11.04 5.85133V7.392H13.4293L13.1193 9.812H11.04V16H15.1167C15.6053 16 16 15.6053 16 15.1173V0.882667C16 0.395333 15.6053 0 15.1173 0Z"
                    fill="#A1B1BA"
                  />
                </svg>
              </span>
              <span @click="shareToTwitter(slug)" class="ico ico-tw">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M14.2857 -0.0183105H1.71429C0.767857 -0.0183105 0 0.751546 0 1.70044V14.3046C0 15.2535 0.767857 16.0234 1.71429 16.0234H14.2857C15.2321 16.0234 16 15.2535 16 14.3046V1.70044C16 0.751546 15.2321 -0.0183105 14.2857 -0.0183105ZM12.5393 5.66789C12.5464 5.76815 12.5464 5.87199 12.5464 5.97225C12.5464 9.07674 10.1893 12.6539 5.88214 12.6539C4.55357 12.6539 3.32143 12.2672 2.28571 11.6012C2.475 11.6226 2.65714 11.6298 2.85 11.6298C3.94643 11.6298 4.95357 11.2574 5.75714 10.6272C4.72857 10.6057 3.86429 9.92895 3.56786 8.99796C3.92857 9.05168 4.25357 9.05168 4.625 8.955C3.55357 8.73657 2.75 7.79126 2.75 6.64901V6.62036C3.06071 6.79582 3.425 6.90324 3.80714 6.91756C3.48587 6.7033 3.22249 6.41263 3.04053 6.07149C2.85856 5.73035 2.76365 5.34935 2.76429 4.96248C2.76429 4.52563 2.87857 4.12459 3.08214 3.77726C4.23571 5.20239 5.96786 6.13338 7.91071 6.23364C7.57857 4.64022 8.76786 3.34757 10.1964 3.34757C10.8714 3.34757 11.4786 3.63045 11.9071 4.08879C12.4357 3.98852 12.9429 3.79158 13.3929 3.52303C13.2179 4.0673 12.85 4.52563 12.3643 4.81567C12.8357 4.76554 13.2929 4.63306 13.7143 4.45044C13.3964 4.91951 12.9964 5.33488 12.5393 5.66789Z"
                      fill="#A1B1BA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span @click="shareToLinkedin(slug)" class="ico ico-li">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.6313 13.6347H11.262V9.922C11.262 9.03667 11.244 7.89733 10.0273 7.89733C8.792 7.89733 8.60333 8.86067 8.60333 9.85667V13.6347H6.234V6H8.51V7.04067H8.54067C8.85867 6.44067 9.632 5.80733 10.7873 5.80733C13.188 5.80733 13.632 7.38733 13.632 9.444V13.6347H13.6313ZM3.558 4.95533C2.79533 4.95533 2.18267 4.338 2.18267 3.57867C2.18267 2.82 2.796 2.20333 3.558 2.20333C4.318 2.20333 4.934 2.82 4.934 3.57867C4.934 4.338 4.31733 4.95533 3.558 4.95533ZM4.746 13.6347H2.37V6H4.746V13.6347ZM14.8167 0H1.18067C0.528 0 0 0.516 0 1.15267V14.8473C0 15.4847 0.528 16 1.18067 16H14.8147C15.4667 16 16 15.4847 16 14.8473V1.15267C16 0.516 15.4667 0 14.8147 0H14.8167Z"
                    fill="#A1B1BA"
                  />
                </svg>
              </span>
              <span
                v-b-popover.top.hover="popupText"
                @click="copytoClipboard(slug)"
                class="ico ico-copy"
                @mouseleave="changePopupText"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.33301 6.66659C6.96482 6.66659 6.66634 6.96506 6.66634 7.33325V13.3333C6.66634 13.7014 6.96482 13.9999 7.33301 13.9999H13.333C13.7012 13.9999 13.9997 13.7014 13.9997 13.3333V7.33325C13.9997 6.96506 13.7012 6.66659 13.333 6.66659H7.33301ZM5.33301 7.33325C5.33301 6.22868 6.22844 5.33325 7.33301 5.33325H13.333C14.4376 5.33325 15.333 6.22868 15.333 7.33325V13.3333C15.333 14.4378 14.4376 15.3333 13.333 15.3333H7.33301C6.22844 15.3333 5.33301 14.4378 5.33301 13.3333V7.33325Z"
                    fill="#A1B1BA"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.66699 2.00008C2.49018 2.00008 2.32061 2.07032 2.19559 2.19534C2.07056 2.32037 2.00033 2.48994 2.00033 2.66675V8.66675C2.00033 8.84356 2.07056 9.01313 2.19559 9.13815C2.32061 9.26318 2.49018 9.33342 2.66699 9.33342H3.33366C3.70185 9.33342 4.00033 9.63189 4.00033 10.0001C4.00033 10.3683 3.70185 10.6667 3.33366 10.6667H2.66699C2.13656 10.6667 1.62785 10.456 1.25278 10.081C0.877706 9.70589 0.666992 9.19718 0.666992 8.66675V2.66675C0.666992 2.13632 0.877706 1.62761 1.25278 1.25253C1.62785 0.877462 2.13656 0.666748 2.66699 0.666748H8.66699C9.19743 0.666748 9.70613 0.877462 10.0812 1.25253C10.4563 1.62761 10.667 2.13631 10.667 2.66675V3.33341C10.667 3.7016 10.3685 4.00008 10.0003 4.00008C9.63214 4.00008 9.33366 3.7016 9.33366 3.33341V2.66675C9.33366 2.48994 9.26342 2.32037 9.1384 2.19534C9.01337 2.07032 8.8438 2.00008 8.66699 2.00008H2.66699Z"
                    fill="#A1B1BA"
                  />
                </svg>
              </span>
            </div>
          </span>
        </h1>
        <div
          v-if="crew && crew.length > 0"
          class="row justify-content-center align-items-center g-2 py-3"
        >
          <div
            v-for="(aCrew, i) in crew"
            class="col text-center"
            :key="`crew_${i}`"
          >
            <b-link class="fw-bolder info">{{ aCrew.nickname }}</b-link>
            <br />
            <span>{{ aCrew.role }}</span>
          </div>
        </div>

        <p class="show-read-more m-3 py-5">
          <tip-tap-output
            :content="description"
            :show-less-char="1000"
            :use-dots="true"
          />
        </p>
        <div class="col-md-6 col-12">
          <div class="row ">
            <div v-if="pages" class="col">
              <span class="fw-bolder text-center">{{ pages }}</span
              ><br />
              <span>Pages</span>
            </div>
            <div
              v-if="reviews"
              class="col text-center"
              style="border-left: 1px solid black;"
            >
              <span class="fw-bolder text-center">{{ reviews }}</span
              ><br />
              <span>Reviews</span>
            </div>
            <div v-if="false" class="col text-center">
              <span class="fw-bolder text-center">4</span><br />
              <span>Authors</span>
            </div>
          </div>
        </div>
        <!-- icon here  -->
        <social-links
          :publishing="corner"
          :user="user"
          :collected-corners="collectedCorners"
          @handleToggleCollectPublishing="handleToggleCollectPublishing"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import config from "@/assets/_config.json";
import BookSection from "./bookSection";
import SocialLinks from "./socialLinks";
import ShareCornerSocial from "@/mixins/ShareCornerSocial.js";
import TipTapOutput from "@/components/common/tipTapOutput";
import { mapGetters } from "vuex";

export default {
  name: "Corner",
  mixins: [ShareCornerSocial],
  components: {
    BookSection,
    SocialLinks,
    TipTapOutput
  },
  props: {
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    collectedCorners: {
      type: Array,
      required: false,
      default: () => []
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      v2: false,
      showSearch: false,
      isViewRecorded: false,
      config,
      showingFullText: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    corner() {
      return {
        doc: this.publishing //TODO MAKE ALL COME FROM PUBLISHING
      };
    },
    title() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.title
          : null
        : null;
    },
    languages() {
      //Return  for books joined/pivoted at language
      return [];
    },
    crew() {
      return this.publishing &&
        this.publishing.crew &&
        Array.isArray(this.publishing.crew)
        ? this.publishing.crew
        : [];
    },
    author() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.author
          : null
        : null;
    },
    description() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.description
          : null
        : null;
    },
    language() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.language
          : null
        : null;
    },
    social() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.title
          : null
        : null;
    },
    copyright() {
      return this.corner && this.corner.doc && this.corner.doc.copyright
        ? this.corner.doc.copyright
        : null;
    },
    reviews() {
      return this.corner && this.corner.doc && this.corner.doc.reviews
        ? this.corner.doc.reviews
        : null;
    },
    pages() {
      return this.corner && this.corner.doc && this.corner.doc.pages
        ? this.corner.doc.pages
        : null;
    },
    slug() {
      return this.corner && this.corner.slug ? this.corner.slug : null;
    }
  },
  methods: {
    handleGoToCornerForLanguage(language) {},
    handleToggleCollectPublishing(data) {
      this.$emit("handleToggleCollectPublishing", data);
    },
    openShare() {
      this.showSearch = !this.showSearch;
    },
    bookMarkBlog() {
      if (this.isBookMarked) {
        let data = {
          type: "remove",
          blog: this.article
        };
        this.$emit("bookMarkBlog", data);
      } else {
        let data = {
          type: "add",
          blog: this.article
        };
        this.$emit("bookMarkBlog", data);
      }
    },
    collectTags() {
      if (!this.user) {
        if (this.corner.doc.seo.length > 0) {
          let existingTags = JSON.parse(Cookies.get("blog_tags"));
          let currentTags = this.corner.doc.seo;
          let allTags = [...existingTags, ...currentTags];
          let uniqTags = [...new Set(allTags)];
          Cookies.set("blog_tags", JSON.stringify(uniqTags));
        }
      } else {
        if (this.corner.doc.seo.length > 0) {
          this.$store.dispatch("user/addBlogTags", this.corner.doc.seo);
        }
      }
    },
    handleImgCoverUploaded() {
      this.$emit("refresh-publishing");
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.corner {
  background-color: #ffc728;
  padding-top: 125px;
  padding-bottom: 60px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .author-wrapper {
    position: relative;
    z-index: 9;
    .other-way {
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 20px;
      position: fixed;
      top: 145px;
      right: 96px;
      .txt {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.03em;
        color: #8d99a0;
      }
      .acts {
        margin-top: 16px;
        display: flex;
        .ico {
          cursor: pointer;
          margin-right: 24px;
          &:hover {
            transform: scale(1.07);
          }
        }
      }
    }
    .author-card {
      position: fixed;
      left: 100px;
      top: 50%;
      transform: translateY(-50%);
      width: 196px;
      z-index: 4;
      .author {
        .profile {
          cursor: pointer;
          display: grid;
          grid-template-columns: 36px 1fr;
          grid-column-gap: 11px;
          align-items: center;
          margin-bottom: 22px;
          img {
            height: 36px;
            width: 36px;
            border-radius: 50%;
            object-fit: cover;
          }
          .name {
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 26px;
            color: #474d52;
            margin-bottom: 0px;
          }
          .email {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.03em;
            text-decoration-line: underline;
            color: #8d99a0;
          }
        }
        .btn-follow {
          border: 1px solid #474d52;
          box-sizing: border-box;
          border-radius: 4px;
          width: 70px;
          height: 28px;
          padding: 0px;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #474d52;
          background-color: #fff;
          transition: 0.2s ease;
          margin-bottom: 24px;
          &:focus {
            box-shadow: none !important;
          }
          &:hover {
            background-color: #474d52;
            color: #fff;
            &:after,
            &:before {
              content: none;
            }
          }
        }
        .followed {
          width: 76px;
          color: #fff;
          background: #474d52;
        }
      }
      .stats {
        margin-top: 4px;
      }
      .author-details {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
      }
    }
  }
  .wrapper {
    max-width: 728px;
    margin: 0 auto;
    padding-top: 47px;
    @media (max-width: 767px) {
      padding: 0 15px;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 40px;
      line-height: 55px;
      color: #474d52;
      margin-bottom: 41px;
      @media (max-width: 767px) {
        font-size: 26px;
        line-height: 34px;
      }
    }
    .content {
      padding-top: 47px;
      font-size: 20px;
      color: #19191a;
      p li {
        font-style: normal;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0.03em;
        margin: 0;
      }
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-top: 49px;
      margin-bottom: 22px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .recommended {
    margin-top: 99px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .guide-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 32px;
    &.recommended-cards {
      margin-bottom: 66px;
    }
  }
}

.show-read-more .more-text {
  display: none;
}
.btn1 {
  border: none;
  color: black;
  background: transparent;
  font-weight: 600;
}

.btn-follow {
  border: 1px solid #474d52;
  box-sizing: border-box;
  border-radius: 4px;
  width: 70px;
  height: 28px;
  padding: 0px;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #474d52;
  background-color: #fff;
  transition: 0.2s ease;
  margin-bottom: 24px;
  &:focus {
    box-shadow: none !important;
  }
  &:hover {
    background-color: #474d52;
    color: #fff;
    &:after,
    &:before {
      content: none;
    }
  }
}

.card {
  background-color: #ffc727;
  border-radius: 10px;
  padding: 10px;
  display: block;
  cursor: pointer;
}
.card:hover {
  background-color: #222222;
  color: #ffc727;
  padding: 10px;
  fill: #ffc727;
  transform: scale(1.05);
}

.ico-bookmark {
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    transform: scale(1.07);
  }
}
.ico-share {
  cursor: pointer;
  position: relative;
  svg {
    &:hover {
      transform: scale(1.07);
    }
  }
  &:active {
    transform: none;
  }
  .share-popup {
    position: absolute;
    width: 150px;
    height: 45px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    top: 100%;
    left: 80%;
    z-index: 3;
    &:hover {
      transform: none;
    }
  }
}
</style>
